<template>
  <div>
    <div class="container-fluid">
      <b-row>
        <b-col class="col">

        </b-col>
      </b-row>

      <b-row style="margin-top: 15px">
        <b-col cols="7" class="tabla-problemas">
          <!--<b-card header="Banco de Problemas"
                  border-variant="light">-->
          <b-row>
            <b-col md="12" style="padding-top: 3%">
              <!--<h3 class="text-uppercase font-weight-bold" style="padding-top: 5%"></h3>-->
              <span class="pull-right pb-2 mr-3">{{totalRows}} revistas de {{scimago_revistas.length}}</span>
            </b-col>
            <!--<b-col md="6" style="padding-top: 4%">
              <b-form-group style="background-color: rgb(228, 231, 234); border-radius: 23px">
                <b-input-group>
                  <b-form-input id="elementsPrependAppend" type="text" v-model="filter" placeholder="" class="buscar"
                                style="background-color: rgb(241, 242, 243);border-color: transparent"></b-form-input>
                  <b-input-group-append>
                    <b-btn type="button" variant="light" :disabled="!filter" @click="filter = ''" class="buscar"><i
                      class="fa fa-search"
                      style="font-size: 24px;color: #1E3375"></i>
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              &lt;!&ndash;<b-form-group horizontal label="" class="mb-0" style="padding-top: 3%">
                <b-input-group>
                  <b-form-input v-model="filter" placeholder=""/>
                  <b-input-group-append>
                    <b-btn type="button" variant="light" :disabled="!filter" @click="filter = ''" ><i class="fa fa-search"
                                                                                                     style="font-size: 24px;color: #D5D9DE"></i>
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>&ndash;&gt;
            </b-col>-->
          </b-row>


          <b-row>
            <b-table :items="scimago_revistas"
                     :fields="fields"
                     :current-page="currentPage"
                     :per-page="perPage"
                     :filter="filter"
                     @filtered="onFiltered" style="color:#1E3375">
              <template slot="HEAD_sjr" slot-scope="data">
                <span v-b-tooltip.hover :title="sjr">{{data.label}}</span>
              </template>
              <template slot="HEAD_hindex" slot-scope="data">
                <span v-b-tooltip.hover :title="hindex">{{data.label}}</span>
              </template>


              <template slot="flat" slot-scope="row">
                <i :class="bandera(row.item.pais)" title="bi" id="bi"></i>
              </template>
              <template slot="show_details" slot-scope="row">
                <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
                <b-button size="sm" @click.stop="row.toggleDetails" variant="light" class="btn btn-pill mr-2">
                  {{ row.detailsShowing ? 'Ocultar' : 'Mostrar'}} Detalles
                </b-button>
                <!-- In some circumstances you may need to use @click.native.stop instead -->
                <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
              </template>
              <template slot="row-details" slot-scope="row">
                <b-card>
                  <b-row class="mb-2">
                    <b-col cols md="auto" class="text-sm-left"><span class="font-weight-bold">Temáticas: </span>
                    </b-col>
                    <b-col cols md="auto">
                      <ul class="list-group list-group-flush">
                        <li class="list-group-item investigador" v-for="item in row.item.tematicas">
                          {{ item }}
                        </li>
                      </ul>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col class="text-sm-left"><span class="font-weight-bold">ISSN: </span>{{row.item.issn }}
                    </b-col>
                  </b-row>
                  <!--<b-row class="mb-2" align-h="end">
                    <b-col cols="3" align-self="end">
                      <b-button size="sm2" @click="row.toggleDetails"
                                class="btn btn-pill btn-block btn-warning">Ocultar detalles</b-button>
                    </b-col>
                  </b-row>-->
                </b-card>
              </template>
            </b-table>
          </b-row>
          <b-row>
            <b-col class="my-1">
              <b-pagination align="center" :total-rows="totalRows" :per-page="perPage"
                            :hide-goto-end-buttons="true"
                            prev-text='<i class="fa fa-caret-left" style="font-size:xx-large!important;color:#D5D9DE"></i>'
                            next-text='<i class="fa fa-caret-right" style="font-size:xx-large!important;color:#D5D9DE"></i>'
                            v-model="currentPage" class="pagination"/>
            </b-col>
          </b-row>
          <!--   </b-card>-->
        </b-col>


        <b-col cols="4" offset-md="1" style="background-color: #F7F7F9" class="selector-problemas">

          <div class="pt-4 text-center">
            <b-form-group style="background-color: rgb(228, 231, 234); border-radius: 23px">
              <b-input-group>
                <b-form-input id="elementsPrependAppend" type="text" v-model="filter" placeholder="Buscar"
                              class="buscar"
                              style="background-color: rgb(241, 242, 243);border-color: transparent"></b-form-input>
                <b-input-group-append>
                  <b-btn type="button" variant="light" :disabled="!filter" @click="filter = ''" class="buscar"><i
                    class="fa fa-search"
                    style="font-size: 24px;color: #1E3375"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <small class="text-center">Buscando en el &aacute;rea de conocimiento <span class="font-weight-bold">{{areaSeleccionada}}</span></small>
          </div>

          <div role="tablist">
            <b-card no-body class="mb-1" style="background-color: #F7F7F9">
              <b-card-header header-tag="header" role="tab" style="background-color: #F7F7F9" class="selector-header">
                <b-btn block href="#" v-b-toggle.dimension variant="light"
                       class="text-left text-uppercase font-weight-bold selector-dimensiones"
                       style="color: #1E3375;background-color: #F7F7F9">
                  <i class="fa fa-caret-down font-3xl text-gray-400"></i><span>Pa&iacute;s</span>
                </b-btn>
              </b-card-header>
              <b-collapse id="dimension" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-list-group>
                    <b-list-group-item button v-for="value in this.pais" :key="value.id"
                                       class="d-flex justify-content-between align-items-center btn-pill listado"
                                       @click="filter = value" id="listado">
                      {{value}}
                      <b-badge variant="light" pill class="lista-badge" id="badge"></b-badge>
                    </b-list-group-item>
                  </b-list-group>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1" style="background-color: #F7F7F9">
              <b-card-header header-tag="header" role="tab" style="background-color: #F7F7F9" class="selector-header">
                <b-btn block href="#" v-b-toggle.quartile variant="light"
                       class="text-left text-uppercase font-weight-bold selector-dimensiones"
                       style="color: #1E3375;background-color: #F7F7F9">
                  <i class="fa fa-caret-down font-3xl text-gray-400"></i><span>Quartile</span>
                </b-btn>
              </b-card-header>
              <b-collapse id="quartile" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-list-group>
                    <b-list-group-item button v-for="value in this.quartile" :key="value.id"
                                       class="d-flex justify-content-between align-items-center btn-pill listado"
                                       @click="filter = value" id="listado">
                      {{value}}
                      <b-badge variant="light" pill class="lista-badge" id="badge"></b-badge>
                    </b-list-group-item>
                  </b-list-group>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1" style="background-color: #F7F7F9">
              <b-card-header header-tag="header" role="tab" style="background-color: #F7F7F9" class="selector-header">
                <b-btn block href="#" v-b-toggle.area variant="light"
                       class="text-left text-uppercase font-weight-bold selector-dimensiones"
                       style="color: #1E3375;background-color: #F7F7F9">
                  <i class="fa fa-caret-down font-3xl text-gray-400"></i><span> &Aacute;reas de conocimiento</span>
                </b-btn>
              </b-card-header>
              <b-collapse id="area" visible accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-list-group>
                    <!--<b-list-group-item button v-for="value in this.area" :key="value.id"
                                       class="d-flex justify-content-between align-items-center btn-pill listado"
                                       @click="filter = value" id="listado">
                      {{value}}
                      <b-badge variant="light" pill class="lista-badge" id="badge"></b-badge>
                    </b-list-group-item>-->
                    <b-list-group-item button
                                       class="d-flex justify-content-between align-items-center btn-pill listado"
                                       @click="filterAll()" id="listado">
                      Todos
                      <b-badge variant="light" pill class="lista-badge" id="badge"></b-badge>
                    </b-list-group-item>
                    <b-list-group-item button
                                       class="d-flex justify-content-between align-items-center btn-pill listado"
                                       @click="filterPsicology()" id="listado">
                      Psicología
                      <b-badge variant="light" pill class="lista-badge" id="badge"></b-badge>
                    </b-list-group-item>
                    <b-list-group-item button
                                       class="d-flex justify-content-between align-items-center btn-pill listado"
                                       @click="filterEducation()" id="listado">
                      Educación
                      <b-badge variant="light" pill class="lista-badge" id="badge"></b-badge>
                    </b-list-group-item>
                    <b-list-group-item button
                                       class="d-flex justify-content-between align-items-center btn-pill listado"
                                       @click="filterLaw()" id="listado">
                      Derecho
                      <b-badge variant="light" pill class="lista-badge" id="badge"></b-badge>
                    </b-list-group-item>
                    <b-list-group-item button
                                       class="d-flex justify-content-between align-items-center btn-pill listado"
                                       @click="filterInformatic()" id="listado">
                      Ciencias de la Computaci&oacute;n
                      <b-badge variant="light" pill class="lista-badge" id="badge"></b-badge>
                    </b-list-group-item>
                    <b-list-group-item button
                                       class="d-flex justify-content-between align-items-center btn-pill listado"
                                       @click="filterBusiness()" id="listado">
                      Negocios, Gestión y Contabilidad
                      <b-badge variant="light" pill class="lista-badge" id="badge"></b-badge>
                    </b-list-group-item>
                  </b-list-group>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>

          <!--<div role="tablist">
            <b-card no-body class="mb-1" style="background-color: #F7F7F9">
              <b-card-header header-tag="header" role="tab" style="background-color: #F7F7F9" class="selector-header">
                <b-btn block href="#" v-b-toggle.dimension variant="light"
                       class="text-left text-uppercase font-weight-bold selector-dimensiones"
                       style="color: #1E3375;background-color: #F7F7F9">
                  <i class="fa fa-caret-down font-3xl text-gray-400"></i><span>Temáticas</span>
                </b-btn>
              </b-card-header>
              <b-collapse id="dimension" visible accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-list-group>
                    <b-list-group-item button v-for="value in this.tematicas" :key="value.id"
                                       class="d-flex justify-content-between align-items-center btn-pill listado"
                                       @click="filter = value.substr(0, value.indexOf('('))" id="listado">
                      {{value}}
                      <b-badge variant="light" pill class="lista-badge" id="badge"></b-badge>
                    </b-list-group-item>
                  </b-list-group>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>-->

        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'

  const {getCode, getName} = require('country-list')

  export default {
    name: "directorio-revistas",
    data() {
      return {
        slide: 0,
        sliding: null,
        problemasData: [],
        fields: {
          nombre: {label: 'Titulo', class: 'v-b-tooltip.hover title="I\'m a tooltip!"'},
          hindex: {label: 'H index', sortable: true},
          quartile: {label: 'Quartile', sortable: true},
          sjr: {label: 'SJR', sortable: true},
          flat: {label: 'País', sortable: true},
          show_details: {label: 'Problema'},
        },
        sjr: 'Es una medida del impacto, influencia o prestigio de la revista. Expresa ' +
          'el número promedio de citas ponderadas recibidas en el año seleccionado por los documentos publicados en la' +
          ' revista en los tres años anteriores.',
        hindex: 'Número de artículos (h) de la revista que han recibido al menos h citas durante todo el período',
        items: [],
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        filter: null,
        ceroBadge: false,
        revistasCopy: null,
        areaSeleccionada: 'Todas  '
      }
    },
    methods: {
      ...mapActions(['getRevistasScimago', 'setRevistasScimago']),
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.scimago_revistas = filteredItems
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      bandera(pais) {
        return "flag-icon flag-icon-" + getCode(pais).toLowerCase() + ' h2'
      },
      tematicaCount(tematica) {
        return this.scimago_revistas.map(item => {
          return item.tematicas
        }).flat()
      },
      filterAll() {
        this.getRevistasScimago()
        this.areaSeleccionada = 'Todas'
        this.onFiltered(this.scimago_revistas)
        this.$root.$emit('bv::refresh::table', 'my-table')
      },
      filterPsicology() {
        if (this.revistasCopy === null)
          this.revistasCopy = this.scimago_revistas;
        this.areaSeleccionada = 'Psicología'
        //let rev = this.scimago_revistas.filter((item) => item.area == 'psicologia')
        this.setRevistasScimago(this.revistasCopy.filter((item) => item.area == 'psicologia'))
        console.info(this.revistas)
        this.onFiltered(this.scimago_revistas.filter((item) => item.area == 'psicologia'))
        this.$root.$emit('bv::refresh::table', 'my-table')
      },
      filterEducation() {
        if (this.revistasCopy === null)
          this.revistasCopy = this.scimago_revistas;
        this.areaSeleccionada = 'Educación'
          this.setRevistasScimago(this.revistasCopy.filter((item) => item.area == 'education'))
        this.onFiltered(this.scimago_revistas.filter((item) => item.area === 'education'))
        this.$root.$emit('bv::refresh::table', 'my-table')
      },
      filterLaw() {
        if (this.revistasCopy === null)
          this.revistasCopy = this.scimago_revistas;
        this.areaSeleccionada = 'Derecho'
          this.setRevistasScimago(this.revistasCopy.filter((item) => item.area == 'law'))
        this.onFiltered(this.scimago_revistas.filter((item) => item.area === 'law'))
        this.$root.$emit('bv::refresh::table', 'my-table')
      },
      filterInformatic() {
        if (this.revistasCopy === null)
          this.revistasCopy = this.scimago_revistas;
        this.areaSeleccionada = 'Ciencias de la Computación'
        this.setRevistasScimago(this.revistasCopy.filter((item) => item.area == 'informatic'))
        this.onFiltered(this.scimago_revistas.filter((item) => item.area === 'informatic'))
        this.$root.$emit('bv::refresh::table', 'my-table')
      },
      filterBusiness() {
        if (this.revistasCopy === null)
          this.revistasCopy = this.scimago_revistas;
        this.areaSeleccionada = 'Negocios, Gestión y Contabilidad'
        this.setRevistasScimago(this.revistasCopy.filter((item) => item.area == 'business'))
        this.onFiltered(this.scimago_revistas.filter((item) => item.area === 'business'))
        this.$root.$emit('bv::refresh::table', 'my-table')
      },


    },
    computed: {
      ...mapGetters(['scimago_revistas']),
      revistas() {
        return this.scimago_revistas
      },
      tematicas() {
        console.log([...new Set(this.scimago_revistas.map(item => {
          return item.tematicas
        }).flat())].filter(it => {
          it == "Clinical Psychology"
        }))
        return [...new Set(this.scimago_revistas.map(item => {
          return item.tematicas
        }).flat())]
      },
      pais() {
        return [...new Set(this.scimago_revistas.map(item => {
          return item.pais
        }).flat())]
      },
      quartile() {
        return [...new Set(this.scimago_revistas.map(item => {
          return item.quartile
        }).flat())]
      },
      area() {
        return [...new Set(this.scimago_revistas.map(item => {
          return item.area
        }).flat())]
      }
    },
    created() {
      this.getRevistasScimago()
    },
  }
</script>

<style scoped>
  table {
    max-width: 98%;
    margin-right: 5px;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/frontend/directorioRevistas.vue